module.exports = monaco;